<script setup>
import { computed } from 'vue';

const props = defineProps({
  initialActiveTab: {
    type: Number,
    default: 0,
  },
  tabs: {
    type: Array,
    required: true,
    validator: value => {
      return value.every(
        tab =>
          typeof tab.label === 'string' &&
          (tab.count ? typeof tab.count === 'number' : true)
      );
    },
  },
});

const emit = defineEmits(['tabChanged']);

const activeTab = computed(() => props.initialActiveTab);

const selectTab = index => {
  emit('tabChanged', props.tabs[index]);
};
</script>

<template>
  <div
    role="tablist"
    class="inline-flex h-9 w-fit items-center justify-center rounded-polaris-lg bg-polaris-muted p-[3px] text-polaris-muted-foreground"
  >
    <button
      v-for="(tab, index) in tabs"
      :key="index"
      type="button"
      role="tab"
      :aria-selected="activeTab === index"
      :data-state="activeTab === index ? 'active' : 'inactive'"
      class="inline-flex h-[calc(100%-1px)] min-w-6 flex-auto items-center justify-center gap-1.5 whitespace-nowrap rounded-polaris-md border border-solid border-transparent px-2 py-1 type-polaris-label text-polaris-foreground dark:text-polaris-muted-foreground transition-[color,box-shadow] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-polaris-ring/50 data-[state=active]:bg-polaris-background data-[state=active]:shadow-sm dark:data-[state=active]:border-polaris-input dark:data-[state=active]:bg-polaris-input/30 dark:data-[state=active]:text-polaris-foreground"
      @click="selectTab(index)"
    >
      <span class="min-w-0 truncate">{{ tab.label }}</span>
      <span
        v-if="tab.count"
        class="shrink-0 tabular-nums text-polaris-muted-foreground"
      >
        {{ tab.count }}
      </span>
    </button>
  </div>
</template>
